import { render } from "./PublicProjectUpload.vue?vue&type=template&id=16082cb4"
import script from "./PublicProjectUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicProjectUpload.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Public/PublicProjectUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16082cb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16082cb4', __exports__)) {
    api.reload('16082cb4', __exports__)
  }
  
  module.hot.accept("./PublicProjectUpload.vue?vue&type=template&id=16082cb4", () => {
    api.rerender('16082cb4', render)
  })

}


export default __exports__